(function () {
  var sections = document.querySelectorAll("[data-ingredients]");

  if (!sections.length || typeof Swiper === "undefined") {
    return;
  }

  sections.forEach(function (section) {
    var slider = section.querySelector("[data-ingredients-swiper]");
    var prev = section.querySelector("[data-ingredients-prev]");
    var next = section.querySelector("[data-ingredients-next]");

    if (!slider) {
      return;
    }

    var swiper = null;
    var mq = window.matchMedia("(max-width: 768px)");

    function enable() {
      if (swiper) {
        return;
      }

      section.classList.add("ingredients--slider");

      swiper = new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 20,
        watchOverflow: true,
        navigation: {
          prevEl: prev,
          nextEl: next,
        },
      });
    }

    function disable() {
      if (swiper) {
        swiper.destroy(true, true);
        swiper = null;
      }

      section.classList.remove("ingredients--slider");
    }

    function sync() {
      if (mq.matches) {
        enable();
      } else {
        disable();
      }
    }

    sync();

    if (typeof mq.addEventListener === "function") {
      mq.addEventListener("change", sync);
    } else if (typeof mq.addListener === "function") {
      mq.addListener(sync);
    }
  });
})();
